/**
 * Template Image Preview Modal
 * Displays full-size template image in a modal
 */

import React from 'react';
import { X } from 'lucide-react';

interface TemplateImagePreviewProps {
  isOpen: boolean;
  imageUrl?: string;
  templateName: string;
  onClose: () => void;
}

export const TemplateImagePreview: React.FC<TemplateImagePreviewProps> = ({
  isOpen,
  imageUrl,
  templateName,
  onClose
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-screen overflow-auto">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b">
          <h2 className="text-xl font-semibold text-gray-900">Xem ảnh</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition"
            title="Đóng"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          <p className="text-sm text-gray-600 mb-4">{templateName}</p>
          {imageUrl ? (
            <img
              src={imageUrl}
              alt={templateName}
              className="w-full h-auto rounded-lg shadow"
              onError={(e) => {
                (e.target as HTMLImageElement).src =
                  'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="400"%3E%3Crect width="400" height="400" fill="%23f3f4f6"/%3E%3Ctext x="50%25" y="50%25" text-anchor="middle" dy=".3em" fill="%239ca3af" font-size="18"%3EKhông thể tải ảnh%3C/text%3E%3C/svg%3E';
              }}
            />
          ) : (
            <div className="w-full h-64 bg-gray-100 rounded-lg flex items-center justify-center">
              <span className="text-gray-400">Không có ảnh</span>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="p-6 border-t flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition font-medium"
          >
            Đóng
          </button>
        </div>
      </div>
    </div>
  );
};

export default TemplateImagePreview;
